$(document).ready(function(){
    $('.tab-collection .custom-tab-layout .tab-content').click(function(){
      let index = $(this).data('index');
      $('.tab-collection .custom-tab-layout .tab-content').removeClass('active');
      $(this).addClass('active');
       // console.log($(this).data('index'));
      $('.tab-collection slider-component').hide();
      $('.tab-collection slider-component[data-index='+index+']').show();
    });
})

// cusotm code for the accordion with image section 
$(document).ready(function(){
   $(".at-title").click(function () {
     let index = $(this).data('index');
     $('.accordion-image').removeClass('active');
     $('.accordion-image[data-index="'+index+'"]').addClass('active');
     console.log(index);
    $(this)
      .toggleClass("active")
      .next(".at-tab")
      .slideToggle()
      .parent()
      .siblings()
      .find(".at-tab")
      .slideUp()
      .prev()
      .removeClass("active");
  });
});

// custom code for the video click 
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.video-button button');
  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      let index = button.getAttribute('data-index');
      let mediaVideo = button.closest('.video-clip-blocks-container').querySelector('video[data-index="' + index + '"]');
      button.classList.add('hide');
      mediaVideo.play();
      mediaVideo.addEventListener('pause', function() {
        button.classList.remove('hide');
      });
    });
  });
  const videos = document.querySelectorAll('.video-button video');
  videos.forEach(function(video) {
    video.addEventListener('click', function() {
      let index = video.getAttribute('data-index');
      let mediaVideo = video;
      let button = video.closest('.video-clip-blocks-container').querySelector('button[data-index="' + index + '"]');
      if (mediaVideo.paused) {
        button.classList.remove('hide');
      } else {
        button.classList.add('hide');
      }
      mediaVideo.addEventListener('play', function() {
        button.classList.add('hide');
      });

      mediaVideo.addEventListener('pause', function() {
        button.classList.remove('hide');
      });
    });
  });
});

// custom js for the footer menu accordion 
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    // if (panel.style.display === "block") {
    //   panel.style.display = "none";
    //   panel.classList.add("my-class");
    // } else {
    //   panel.style.display = "block";
    //   panel.classList.remove("my-class");
    // }
    if (panel.classList.contains('active-content')) {
          panel.classList.remove("active-content");
        } else {
          panel.classList.add("active-content");
    }
  });
}
// custom js for the accordion tab section 
 $(document).ready(function(){
    $('.accordion-tabs-section-container .accordion-layout .accordion-headings .block-accordion-heading').on('click', function(){
      let index = $(this).data('index');
      $('.accordion-layout .accordion-headings .block-accordion-heading').removeClass('active');
      $(this).addClass('active');
      $('.accordion-content-layout').hide();
      $('.accordion-content-layout[data-index="'+index+'"]').show();
    });
   $('.accordion-tabs-section-container .faq-tabs-layout .tabs-heading .block-tab-heading').on('click', function(){
      let index = $(this).data('index');
      // console.log(index);
     $('.accordion-tabs-section-container .faq-tabs-layout .tabs-heading .block-tab-heading').removeClass('active');
      $(this).addClass('active');
      $('.tab-faq-content').hide();
      $('.tab-faq-content[data-index="'+index+'"]').show();
    });
 });

// custom code for the cart drawer donation of the 28-01-2025
document.addEventListener("change", function(event) {
  if(event.target.hasAttribute("donation")){
    let removeChecked = document.querySelectorAll('[donation]');
    removeChecked.forEach((check) => {
      check.removeAttribute('checked',false);
      localStorage.removeItem("selectedDeliveryOption");
      localStorage.setItem('selectedDeliveryOption', event.target.getAttribute('id'));
    });
    const varaintID = event.target.getAttribute('id');
    const cartDonation = document.querySelector('[data-donation]');
    
    if(cartDonation){
       cartDonation.click();
    }
    
    setTimeout(async () => {
      let formData = {
       'items': [{
        'id': varaintID,
        'quantity': 1,
         'properties': {'donation':'donation'}
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(formData)
      })
     .then(async (response) => { 
       const donationAdd = await response.json();
        $('cart-drawer').load(window.location.href + ' #CartDrawer');
       //console.log(donationAdd);
     })
     .catch((error) => { console.log(error.message); });
    },1000);
     setTimeout(() => {
        const selectedOption = localStorage.getItem('selectedDeliveryOption');
       // console.log(selectedOption);
        if (selectedOption) {
          document.getElementById(selectedOption).setAttribute('checked',true);
          const parent = document.getElementById(selectedOption).parentElement;
           parent.classList.add('active');
        }
    },3000);
  }
});
document.addEventListener('DOMContentLoaded', function() {
  const selectedOption = localStorage.getItem('selectedDeliveryOption');
   if (selectedOption) {
     document.getElementById(selectedOption).setAttribute('checked',true);
     const parent = document.getElementById(selectedOption).parentElement;
     parent.classList.add('active');
    }
});